import * as React from 'react';
import { toast } from 'react-toastify';
import { formatNumber, splitByUppercase } from '../Common/Utilities';
import { httpGet, httpPost } from '../../HttpRequestHandling/httpRequestHandler';
import EnhancedDataGrid from '../Common/EnhancedDataGrid';
import RemoveIcon from '@mui/icons-material/Remove';
import { Check } from '@mui/icons-material';
import ServerExportWrapper from '../Common/DataGridServerExportWrapper';
import { MUIButton } from '../Common/Components/MuiButton';
import { getFilter, setFilter } from '../Common/Utilities';
import { getGridNumericOperators } from '@mui/x-data-grid';

const numberFilterOperators = getGridNumericOperators().map((op) => {
	const labelMap = {
		'=': 'is equal to',
		'!=': 'is not equal to',
		'>': 'is greater than',
		'>=': 'is greater than or equal to',
		'<': 'is less than',
		'<=': 'is less than or equal to',
		'isEmpty': 'is empty',
		'isNotEmpty': 'is not empty',
	};
	return { ...op, label: labelMap[op.value] ?? op.label };
});

export default class PurchaseOrdersReport extends React.Component {
	constructor() {
		super();

		const persisted = getFilter(["Reports", "PurchaseOrdersReport"]) || {};
		const nineWeeksAgo = new Date();
		nineWeeksAgo.setDate(nineWeeksAgo.getDate() - 63);

		const defaultFilterModel = {
			items: [{
				field: 'createDate',
				operator: 'after',
				value: nineWeeksAgo.toISOString().split('T')[0]
			}],
			logicOperator: 'and'
		};

		this.state = {
			data: [],
			filterText: persisted.filterText ?? '',
			lastFilterText: '',
			filterModel: persisted.filterModel ?? defaultFilterModel,
			columnVisibility: persisted.columnVisibility || {},
			tempTableEnabled: false,
			exportData: [],
			dataLoaded: false,
			isServerMode: false,
			defaultFilter: { ...defaultFilterModel.items[0] },
			hasSearched: persisted.hasSearched ?? false,
			sortModel: persisted.sortModel || []
		};

		this.mainGridRef = React.createRef();
		this.searchCallback = this.searchCallback.bind(this);
		this.fieldInModel = this.fieldInModel.bind(this);
		this.normalizeFilterModel = this.normalizeFilterModel.bind(this);
	}

	componentDidMount() {

		const gridRef = this.mainGridRef.current;

		const { filterModel, filterText, hasSearched } = this.state;
		gridRef.setFilterModel({
			...filterModel,
			quickFilterValues: ['']
		});
		if (gridRef && typeof gridRef.setQuickFilterValues === 'function') {
			gridRef.setQuickFilterValues([filterText]);
		}
		this.fetchPurchaseOrders(filterModel, hasSearched ? filterText : '');
		setFilter(['Reports', 'PurchaseOrdersReport'], {
			...getFilter(['Reports', 'PurchaseOrderReport']),
			hasSearched,
			filterText,
			filterModel,
			columnVisibility: this.state.columnVisibility
		});
	}

	fetchPurchaseOrders(filterModel, searchText, exportData) {
		var that = this;

		this.props.inProgress(true);
		let _uFilterModel = this.getFilterItems(filterModel);
		httpPost('/api/reports/purchaseorders', {
			searchFilter: searchText,
			otherFilters: JSON.stringify((_uFilterModel.items || []).
				map(f => ({
					field: splitByUppercase(f.field).join('_'),
					operator: f.operator,
					value: (f.operator === 'isEmpty' || f.operator === 'isNotEmpty') ? true : f.value,
				}))
				.filter(f => f.value !== undefined && f.value !== '')),
			logicOperator: _uFilterModel.logicOperator,
			isAll: !!exportData
		})
			.then((response) => {
				var data = (response.data || []).map((e, i) => { let d = { ...e, rowId: i }; return d });
				if (!!exportData) {
					that.setState({ ...this.state, exportData: data, dataLoaded: true });
				}
				else {
					that.setState({ data: data });
				}

				this.props.inProgress(false);
			})
			.catch((error) => {
				this.props.inProgress(false);
				toast.error('An error occurred while fetching the records');
				console.error('There was an error!', error);
			});
	}
	searchCallback = (searchText) => {
		const trimmedText = (searchText || "").trim();
		const prevText = this.state.lastFilterText;
		if (trimmedText === "" && prevText !== "") {
			this.setState({ lastFilterText: "" }, () => {
				this.fetchPurchaseOrders(this.state.filterModel, searchText);

			});
			return;
		}
		if (trimmedText !== "" && trimmedText !== prevText) {
			this.setState({ lastFilterText: trimmedText }, () => {
				this.fetchPurchaseOrders(this.state.filterModel, searchText);

			});
		}
	}
	getFilterItems(filterModel) {
		//const hasDueDateFilter = this.fieldInModel(filterModel, 'dueDate', ['after', 'onOrAfter', 'before', 'onOrBefore']);
		//let _filterModel = structuredClone(filterModel);

		//if (this.state.isServerMode && !hasDueDateFilter) {
		//	_filterModel.items = _filterModel.items || [];
		//	_filterModel.logicOperator = _filterModel.logicOperator || 'and';
		//	_filterModel.items.push(this.state.defaultFilter);
		//}

		//return _filterModel;
		return filterModel;
	}
	fieldInModel(model, fieldName) {
		const relevantOperators = ['after', 'onOrAfter', 'before', 'onOrBefore'];
		return model.items?.some(f =>
			f.field === fieldName && (
				!f.operator || relevantOperators.includes(f.operator)
			)
		);
	}

	normalizeFilterModel(model) {
		return {
			items: [...(model?.items || [])],
			logicOperator: model?.logicOperator || 'and'
		};
	}

	handleFilterPanelSearch = (incomingFilterModel, quickFilterText = '') => {

		const normalizedModel = this.normalizeFilterModel(incomingFilterModel);
		//const isServerMode = !this.fieldInModel(normalizedModel, 'dueDate');

		this.setState({
			filterModel: normalizedModel,
			filterText: quickFilterText,
			hasSearched: true,
			//isServerMode
		}, () => {
			setFilter(['Reports', 'PurchaseOrdersReport'], {
				filterModel: normalizedModel,
				filterText: quickFilterText,
				columnVisibility: this.state.columnVisibility,
				hasSearched: true,
			});
			// ✅ Now it will fetch data
			this.fetchPurchaseOrders(normalizedModel, quickFilterText);
		});
	}
	render() {
		const cellStyle = { paddingLeft: 8, paddingRight: 45 };
		const filterCellStyle = { textAlign: 'right', paddingRight: 45 };
		const headerStyle = { textAlign: 'right' };

		const columns = [
			{
				headerName: 'Vendor',
				field: 'vendor',
				width: 200,
			},
			{
				headerName: 'IO/PO Number',
				field: 'poCode',
				width: 150, hideable: false
			},
			{
				headerName: 'Project',
				field: 'level2Key',
				width: 240,
			},
			{
				headerName: 'Project Name',
				field: 'level2Description',
				width: 350,
			},
			{
				headerName: 'Activity',
				field: 'level3Key',
				width: 250,
			},
			{
				headerName: 'Due Date',
				field: 'dueDate',
				type: 'date',
				valueGetter: ({ value }) => (value && new Date(value)),
				width: 200,
			},
			{
				headerName: 'Quantity',
				field: 'quantity',
				type: 'numeric', align: 'right',
				headerAlign: 'right',
				valueGetter: ({ value }) => (value && Number(value)) || 0,
				width: 150,
				filterOperators: numberFilterOperators,
			},
			{
				headerName: 'Net Cost',
				field: 'netCost',
				type: 'number',
				align: 'right',
				headerAlign: 'right',
				width: 200,
				filterOperators: numberFilterOperators,
				renderCell: rowData => <span style={{ display: 'block', textAlign: 'right', width: '100%' }}>{formatNumber(rowData.row.netCost) + " " + (rowData.row.currencyCode || "")}</span>,
				valueFormatter: (scope) => {
					const row = scope.row || (scope.api && scope.api.getRow(scope.id));
					return formatNumber(row?.netCost) + " " + (row?.currencyCode || "");
				},
				getExportValue: (row) => formatNumber(row.netCost) + " " + (row.currencyCode || "")
			},
			{
				headerName: 'Match to Date Net',
				field: 'matchToDateNet',
				type: 'number',
				align: 'right',
				headerAlign: 'right',
				width: 150,
				valueGetter: ({ value }) => (value && Number(value)) || 0,
				width: 150,
				filterOperators: numberFilterOperators,
				renderCell: rowData => <span style={{ display: 'block', textAlign: 'right', width: '100%' }}>{formatNumber(rowData.row.matchToDateNet) + " " + (rowData.row.currencyCode || "")}</span>,
				valueFormatter: (scope) => {
					const row = scope.row || (scope.api && scope.api.getRow(scope.id));
					return formatNumber(row?.matchToDateNet) + " " + (row?.currencyCode || "");
				},
				getExportValue: (row) => formatNumber(row.matchToDateNet) + " " + (row.currencyCode || "")
			},
			{
				headerName: 'Closed',
				field: 'closeFlag',
				type: 'boolean',
				renderCell: (props) => {
					return (
						(props?.row?.activeFlag) ?
							<Check key={props?.row.rowId} color={'action'} /> :
							<RemoveIcon key={props?.row.rowId} color={'action'} />

					)
				},
				width: 150,
			},
			{
				headerName: 'Create Date',
				field: 'createDate',
				type: 'date',
				hideable: false,
				valueGetter: ({ value }) => value && new Date(value),
				width: 200
			},
		];
		let filterMode = this.state.isServerMode ? { filterMode: 'server' } : {};
		return (
			<div>
				<h1>Purchase Orders</h1>
				<div className="form-group">
					<div style={{ display: 'block', overflow: 'auto', width: '100%' }}>
						<EnhancedDataGrid rows={this.state.data}
							disableColumnMenu
							pagination
							pageSize={10}

							columns={columns}
							options={{
								pageSize: 10,
								pageSizeOptions: [10, 20, 30, 40, 50],
								maxBodyHeight: 670,
								filtering: true,
								columnsButton: true,
								exportButton: true,
								exportAllData: true,
								exportFileName: "PurchaseOrders"
							}}
							gridRef={this.mainGridRef}
							getRowId={(row) => row.rowId}
							disableSelectionOnClick
							{...filterMode}
							searchCallback={null}
							customcomponent={
								<>
									{/*{this.getSearchButton()}*/}
								</>
							}
							setFilterText={(text) => {

								const trimmedText = text?.trim() || '';
								const stored = getFilter(['Reports', 'PurchaseOrdersReport']) || {};

								if (trimmedText === stored.filterText) return;

								const shouldResetSearch = stored.hasSearched && stored.filterText !== trimmedText;
								const nextHasSearched = shouldResetSearch ? false : stored.hasSearched;

								this.setState({ ...this.state, filterText: text, hasSearched: nextHasSearched })

								setFilter(['Reports', 'PurchaseOrdersReport'], {
									...stored,
									filterText: trimmedText,
									hasSearched: nextHasSearched,
								});
							}}
							highlightSearchTextOnMainScreenGrid={true}
							onColumnVisbilityModelChange={(model) => {
								this.setState({ columnVisibility: model });
								setFilter(['Reports', 'PurchaseOrdersReport'], {
									...getFilter(['Reports', 'PurchaseOrdersReport']),
									columnVisibility: model,
								});
							}}
							columnVisibilityModel={this.state.columnVisibility}
							onSortModelChange={(model) => {
								this.setState({ sortModel: model });
								setFilter(['Reports', 'PurchaseOrdersReport', 'sortModel'], model);
							}}
							sortModel={this.state.sortModel}
							setFilterModel={(model) => {
								//const prevHadDueDate = this.fieldInModel(this.state.filterModel, 'dueDate');
								//const newHasDueDate = this.fieldInModel(model, 'dueDate');

								//const prevDateFilter = this.state.filterModel.items.find(f => f.field === 'dueDate');
								//const newDateFilter = model.items.find(f => f.field === 'dueDate');

								//const isDateChanged = prevDateFilter && newDateFilter &&
								//	(prevDateFilter.operator !== newDateFilter.operator || prevDateFilter.value !== newDateFilter.value);

								//this.setState({
								//	filterModel: { items: [...model.items], logicOperator: model.logicOperator },
								//	isServerMode: !newHasDueDate
								//}, () => {
								//	const shouldRefetch =
								//		(prevHadDueDate !== newHasDueDate) ||       // dueDate added or removed
								//		(!this.state.isServerMode && isDateChanged); // dueDate changed while in client mode

								//	if (shouldRefetch) {
								//		this.fetchPurchaseOrders(model, this.state.filterText);
								//	}

								//	this.mainGridRef.current?.setFilterModel({
								//		...model,
								//		quickFilterValues: [this.state.filterText]
								//	});
								//});
							}}
							onFilterPanelSearch={(filterModel, quickFilterText) => {
								this.handleFilterPanelSearch(filterModel, quickFilterText);
							}}
							customFilterPanel={true}
							customServerFilter={() => this.state.isServerMode ? () => { } : undefined}
							exportServerCallback={() => {
								this.setState(prev => {
									return { ...prev, tempTableEnabled: true }
								}, () => {
									this.fetchPurchaseOrders(this.state.filterModel, this.state.filterText, true);
								})
							}}
							footerMessage={''}
						/>
						{
							this.state.tempTableEnabled ?

								<ServerExportWrapper
									rows={this.state.exportData}
									initialState={{
										columns: {
											columnVisibilityModel: {
												...this.mainGridRef.current.exportState().columns.columnVisibilityModel
											},
										},
									}}
									columns={columns}
									options={{
										exportFileName: "PurchaseOrders"
									}}
									dataLoaded={this.state.dataLoaded}
									getRowId={(row) => row.rowId}
									resetStates={() => {
										this.setState({
											...this.state,
											tempTableEnabled: false,
											dataLoaded: false,
											exportData: []
										})
									}}
								/>
								:
								<></>
						}
					</div>
				</div>
			</div>
		);
	}
}